<app-loading *ngIf="contentReady"></app-loading>

@if(!noData && tokenExists) {
<div class="orders-vcash-page" style="margin-bottom: 70px;">

  <!-- TOP AREA -->
  <section class="orders-top">
    <div class="orders-appbar">
      <button class="orders-appbar-btn" type="button" (click)="goBack()">
        <img
          [src]="isAr ? '/assets/e-commerce/icons/60.webp' : '/assets/e-commerce/icons/61.webp'"
          alt="back"
        />
      </button>

      <h1 class="orders-appbar-title">
        {{ isAr ? "حجوزاتي" : "My Bookings" }}
      </h1>

      <div class="orders-appbar-count">
        {{ allData?.length || 0 }}
      </div>
    </div>
  </section>

  <!-- CONTENT -->
  <div class="orders-content">

    <!-- OVERVIEW CARD -->
    <section class="orders-overview-card">
      <div class="orders-overview-top">
        <div class="orders-overview-main">
          <span class="orders-overline">
            {{ isAr ? "خدمات العيادة" : "Clinic Services" }}
          </span>

          <h2>{{ allData?.length || 0 }}</h2>

          <p>
            {{
              isAr
                ? "تابع حجوزات العيادة والجرومينج الخاصة بحيوانك الأليف بسهولة"
                : "Track your clinic and grooming bookings easily"
            }}
          </p>
        </div>

        <div class="orders-overview-side">
          <span>{{ isAr ? "عدد الحجوزات" : "Bookings" }}</span>
          <strong>{{ bookingsTotal || allData?.length || 0 }}</strong>
        </div>
      </div>
    </section>

    <!-- BOOKINGS LIST -->
    <section class="orders-list-section">
      <div class="orders-section-header">
        <h3>{{ isAr ? "أحدث الحجوزات" : "Recent Bookings" }}</h3>
      </div>

      <div class="orders-list">
        <div class="order-modern-card" *ngFor="let booking of allData">

          <div class="order-modern-top">

            <!-- SERVICE IMAGE / ICON -->
            <div class="order-status-media">
              @if(getService(booking)?.image) {
                <img
                  [src]="getService(booking)?.image"
                  alt="service"
                  class="order-status-img service-img"
                />
              } @else {
                <img
                  src="/assets/e-commerce/icons/67.webp"
                  alt="service"
                  class="order-status-img"
                />
              }
            </div>

            <!-- MAIN INFO -->
            <div class="order-modern-main">

              <div class="order-modern-row">
                <span class="status-label status-label--approved">
                  {{ isAr ? "تم الحجز" : "Booked" }}
                </span>

                @if(getServicePrice(booking)) {
                  <div class="order-total-pill">
                    {{ getServicePrice(booking) }} {{ "egpe" | transloco }}
                  </div>
                }
              </div>

              <div class="service-name-line">
                {{ getServiceName(booking) }}
              </div>

              <div class="order-meta-line">
                {{ isAr ? "ميعاد الحجز" : "Booking date" }}:
                <strong>{{ convertDateTime(booking.booking_date) }}</strong>
              </div>

              <div class="order-number-line">
                {{ isAr ? "رقم الحجز" : "Booking number" }}
                <strong>#{{ booking.id }}</strong>
              </div>

              <div class="booking-info-box">
                <div class="booking-info-row">
                  <span>{{ isAr ? "نوع الحيوان" : "Pet type" }}</span>
                  <strong>{{ getPetTypeLabel(booking.pet_type) }}</strong>
                </div>

                <div class="booking-info-row">
                  <span>{{ isAr ? "اسم العميل" : "Client name" }}</span>
                  <strong>{{ booking.client_name || "-" }}</strong>
                </div>

                <div class="booking-info-row">
                  <span>{{ isAr ? "رقم الهاتف" : "Phone" }}</span>
                  <strong>{{ booking.phone_number || "-" }}</strong>
                </div>

                @if(booking.from_website) {
                  <div class="booking-info-row">
                    <span>{{ isAr ? "مصدر الحجز" : "Source" }}</span>
                    <strong>{{ booking.from_website }}</strong>
                  </div>
                }
              </div>

            </div>
          </div>

          <!-- ACTIONS -->
          <div class="order-action-grid">
            @if(booking.phone_number) {
              <button
                class="order-chip order-chip--call"
                type="button"
                (click)="callClient(booking.phone_number)"
              >
                {{ isAr ? "اتصال" : "Call" }}
              </button>

              <button
                class="order-chip order-chip--approved"
                type="button"
                (click)="chatClient(booking.phone_number)"
              >
                {{ isAr ? "واتساب" : "WhatsApp" }}
              </button>
            }

            <button
              class="order-chip order-chip--rejected"
              type="button"
              (click)="deleteBooking(booking.id)"
            >
              {{ isAr ? "إلغاء الحجز" : "Cancel booking" }}
            </button>
          </div>

        </div>
      </div>
    </section>
  </div>
</div>
}
@else {
  <app-emptyservices></app-emptyservices>
}